export default __webpack_public_path__ + "static/media/facebook-icon.da5252c0.svg";